export const DEFAULT_OWN_FARMING_URL =
  process.env.APP_ENV === "production"
    ? "https://svoefermerstvo.ru/"
    : "https://svoefermerstvo-dev.sz.rshbcloud.ru/";
